import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Define the initial state
const initialState = {
  loading: false,
  success: false,
  error: null,
};

// Create the async thunk to make the POST request
export const requestUnit = createAsyncThunk(
  'unitRequest/requestUnit',
  async ({ customerFk, equipmentId, token }) => {
    try {
      const response = await axiosInstance.post(
        '/api/Customer/RequestUnitCustomer',
        { customerFk, equipmentId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
);

// Create the slice
const unitRequestSlice = createSlice({
  name: 'unitRequest',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestUnit.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(requestUnit.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(requestUnit.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || 'An error occurred';
      });
  },
});

// Export actions and reducer
export default unitRequestSlice.reducer;
